import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { OrientationService } from '../../services/orientation.service'; // ✅ adjust path as needed

@Component({
  selector: 'app-landscape-alert',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="landscape-overlay" *ngIf="showWarning">
      <div class="landscape-alert">
        <div class="alert-icon">
          <!-- Portrait phone icon -->
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="icon-portrait">
            <rect x="7" y="2" width="10" height="20" rx="2"></rect>
            <circle cx="12" cy="18" r="1" fill="currentColor"></circle>
          </svg>
          <!-- Arrow hint -->
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="icon-arrow">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
          <!-- Landscape phone (rotated) -->
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"
               viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="icon-landscape">
            <rect x="7" y="2" width="10" height="20" rx="2" transform="rotate(90 12 12)"></rect>
            <circle cx="18" cy="12" r="1" fill="currentColor"></circle>
          </svg>
        </div>
        <h3>Rotate Your Device</h3>
        <p>This app works best in <strong>portrait mode</strong>. Please rotate your phone upright.</p>
      </div>
    </div>
  `,
  styles: [`
    .landscape-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.92);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      backdrop-filter: blur(8px);
      animation: fadeIn 0.3s ease;
    }

    .landscape-alert {
      background: #fff;
      border-radius: 20px;
      padding: 2rem 1.5rem;
      text-align: center;
      max-width: 300px;
      margin: 20px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
      animation: slideUp 0.3s ease;
    }

    .alert-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
      margin-bottom: 1.5rem;
      color: #f59e0b;
    }

    .icon-portrait {
      animation: none;
    }

    .icon-arrow {
      color: #9ca3af;
    }

    .icon-landscape {
      animation: rotateHint 2s ease-in-out infinite;
    }

    h3 {
      margin: 0 0 0.5rem;
      font-size: 1.4rem;
      font-weight: 700;
      color: #111;
    }

    p {
      margin: 0;
      color: #555;
      font-size: 0.95rem;
      line-height: 1.6;
    }

    p strong {
      color: #111;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    @keyframes slideUp {
      from { transform: translateY(24px); opacity: 0; }
      to   { transform: translateY(0);    opacity: 1; }
    }

    @keyframes rotateHint {
      0%, 100% { transform: rotate(0deg);   }
      40%, 60% { transform: rotate(-90deg); }
    }

    @media (prefers-color-scheme: dark) {
      .landscape-alert { background: #1c1c1e; }
      h3              { color: #f5f5f5; }
      p               { color: #a1a1aa; }
      p strong        { color: #f5f5f5; }
    }
  `]
})
export class LandscapeAlertComponent implements OnInit, OnDestroy {
  showWarning = false;
  private sub?: Subscription;

  constructor(private orientationService: OrientationService) {}

  ngOnInit() {
    this.sub = this.orientationService.orientation$.subscribe((info) => {
      this.showWarning = info.isMobile && info.isLandscape;
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}